import Vue from 'vue';

import moment from 'moment';
import { nest } from 'utils/nest';
import { each, pickBy, find } from 'lodash';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

export default {
  components: {
    NuttremaLoader,
    NuttremaEmptyResult,
  },
  data() {
    return {
      grouping: {
        list: [],
        selected: {},
      },
      sorting: {
        list: [],
        selected: null,
      },
      orders: {
        list: ['asc', 'desc', 'test'],
        selected: 'asc',
      },
    };
  },
  methods: {
    groupByDate(items, key) {
      const startOfWeek = moment().startOf('isoWeek');
      const endOfWeek = moment().endOf('isoWeek');
      const startOfMonth = moment().startOf('month');
      const endOfMonth = moment().endOf('month');

      const groups = {
        not_defined: [],
        this_week: [],
        previous_week: [],
        this_month: [],
        after_this_month: [],
        before_this_month: [],
      };

      each(items, (item) => {
        let group = 'not_defined';
        const current = moment(item[key]);

        if (current.isAfter(endOfMonth)) group = 'after_this_month';
        else if (current.isBetween(startOfWeek, endOfWeek, null, '[]')) group = 'this_week';
        else if (current.isBetween(startOfMonth, endOfMonth, null, '[]')) group = 'this_month';
        else if (current.isBefore(startOfMonth)) group = 'before_this_month';

        groups[group].push(item);
      });

      return pickBy(groups, group => group.length > 0);
    },
    groupByProperty(items, keys) {
      return nest(items, keys);
    },
    onChangeGroupBy(key) {
      const selected = find(this.grouping.list, { key });
      if (selected) this.grouping.selected = selected;
    },
    onChangeSortBy(key) {
      const selected = find(this.sorting.list, { key });
      if (selected) this.sorting.selected = selected;
    },
    onChangeOrder(key) {
      Vue.set(this.orders, 'selected', key);
    },
    order() {},
  },
  computed: {
    list() {
      let grouped = null;
      const groupBy = [];
      const ordered = this.order();

      const selectedGrouping = this.grouping.selected;
      groupBy.push(selectedGrouping.key);

      switch (selectedGrouping.type) {
        case 'date':
          grouped = this.groupByDate(ordered, selectedGrouping.key);
          break;
        default:
        case 'property':
          grouped = this.groupByProperty(ordered, groupBy);
          break;
      }
      return grouped;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/virtual-grouping.js